<template>
    <div class="base-layout">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'BaseLayout'
};
</script>
